import { SVGProps } from 'react';

export const SvgEye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M1.66699 9.99984C1.66699 9.99984 4.16699 4.1665 10.0003 4.1665C15.8337 4.1665 18.3337 9.99984 18.3337 9.99984C18.3337 9.99984 15.8337 15.8332 10.0003 15.8332C4.16699 15.8332 1.66699 9.99984 1.66699 9.99984Z"
      stroke={props.color ?? 'black'}
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0003 12.4998C11.381 12.4998 12.5003 11.3805 12.5003 9.99984C12.5003 8.61913 11.381 7.49984 10.0003 7.49984C8.61961 7.49984 7.50033 8.61913 7.50033 9.99984C7.50033 11.3805 8.61961 12.4998 10.0003 12.4998Z"
      stroke={props.color ?? 'black'}
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
